var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.08398V3.33398C12.5 4.51249 12.5 5.10175 12.8661 5.46787C13.2322 5.83398 13.8215 5.83398 15 5.83398H16.25",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 13.3327V6.66602C3.33203 4.30899 3.33203 3.13048 4.06426 2.39825C4.7965 1.66602 5.97501 1.66602 8.33203 1.66602H11.8084C12.1489 1.66602 12.3193 1.66602 12.4724 1.72945C12.6255 1.79288 12.746 1.91332 12.9869 2.15417L16.1772 5.34452C16.418 5.58538 16.5385 5.70582 16.6019 5.85896C16.6654 6.0121 16.6654 6.18242 16.6654 6.52304V13.3327C16.6654 15.6897 16.6654 16.8682 15.9331 17.6004C15.2009 18.3327 14.0224 18.3327 11.6654 18.3327H8.33203C5.97501 18.3327 4.7965 18.3327 4.06426 17.6004C3.33203 16.8682 3.33203 15.6897 3.33203 13.3327Z",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 9.16602H13.3346M6.66797 11.666H13.3346M6.66797 14.166H10.1436",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarDocs);
export default __webpack_public_path__ + "static/media/side-bar-docs.abd832f85fad16cc8f02bf2ddf9e055e.svg";
export { ForwardRef as ReactComponent };